import type { ReactNode } from "react";
import type { Funnel } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Maintenance } from "../Maintenance";
import { getMaintenanceMessages } from "@/utilities/getMaintenanceMessages";
import { useMaintenanceMode } from "@/utilities/hooks/useMaintenanceMode";

interface FunnelMaintenanceGuardProps {
  funnel: Funnel;
  children: ReactNode;
}

export const FunnelMaintenanceGuard = ({
  funnel,
  children,
}: FunnelMaintenanceGuardProps) => {
  const { language } = useI18nContext();
  const { isFunnelUnderMaintenance, maintenancePayload } = useMaintenanceMode();

  if (isFunnelUnderMaintenance(funnel)) {
    const { title, subtitle } = getMaintenanceMessages(
      language,
      maintenancePayload
    );
    return <Maintenance title={title} subtitle={subtitle} />;
  }

  return <>{children}</>;
};
